module.exports = __webpack_public_path__ + "static/media/avatar-empty.d66c8dc3.jpg";